module.exports = __webpack_public_path__ + "img/SEATER.1c0fe80b.svg";